<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="py-5">
          <v-toolbar flat>
            <v-col cols="12" class="px-0 py-5">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Month
                    <div class="month-label">
                      {{
                        `${formatDate(this.dates[0])} - ${formatDate(
                          this.dates[1]
                        )}`
                      }}
                      Report
                    </div>
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="dates"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Choose Dates
                      </v-btn>
                    </template>
                    <v-date-picker v-model="dates" range>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(dates)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>

                  <v-autocomplete
                    :items="dealers"
                    v-model="currentDealer"
                    item-text="fullname"
                    item-value="dealerId"
                    label="Select Dealer"
                    class="ml-2 mt-2"
                  ></v-autocomplete>
                  <!-- <v-select
                    :items="dealers"
                    label="Select Dealer"
                    dense
                    class="ml-2 mt-2"
                    item-value="dealerId"
                    v-model="currentDealer"
                    item-text="fullname"
                  >
                  </v-select> -->
                </div>
              </div>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
          </v-toolbar>

          <!-- <v-divider></v-divider> -->
        </v-card>
      </v-col>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Retailer Transactions
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <!-- <div class="my-5"> -->
                  <!-- <v-select
                    :items="reportList"
                    item-text="text"
                    item-value="value"
                    v-model="reportSelected"
                    label="Select Report"
                    class="ml-2 mt-5 px-2"
                    :disabled="table.data.length <= 0"
                  ></v-select> -->
                  <v-btn color="primary" class="my-4" @click="exportCSV">
                    <v-icon dense>mdi-download</v-icon>
                    Export
                  </v-btn>
                  <v-switch
                    v-model="isShowBal"
                    class="px-2 mt-6"
                    flat
                    label="Show 0 Balance"
                    @change="showZeroBalance()"
                    :disabled="table.data.length <= 0"
                  ></v-switch>
                  <!-- </div> -->

                  <!-- <div class="my-3">
                    <v-btn color="primary">
                      <download-csv
                        :data="exportData"
                        :name="`${fileName}.csv`"
                      >
                        <v-icon dense>mdi-download</v-icon>
                        Export
                      </download-csv>
                    </v-btn>
                  </div> -->
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            :single-expand="table.singleExpand"
            :expanded.sync="table.expanded"
            show-expand
            item-key="retailerId"
            :search="search"
            :item-class="row_classes"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template v-slot:expanded-item="{ item }">
              <td class="p-0" :colspan="subTable.headers.length">
                <v-data-table
                  :headers="subTable.headers"
                  :items="
                    item.transactions.length > 0
                      ? item.transactions
                      : transactions.map((v) => ({
                          ...v,
                          retailerId: item.retailerId,
                        }))
                  "
                  :loading="table.loading"
                  hide-default-footer
                  disable-pagination
                  loading-text="Loading... Please wait"
                  class="sub-areas"
                >
                  <template v-slot:[`item.data-table-expand`]></template>
                  <template
                    v-for="header in subTable.headers.filter((header) =>
                      header.hasOwnProperty('formatter')
                    )"
                    v-slot:[`item.${header.value}`]="{ value }"
                  >
                    {{ header.formatter(value) }}
                  </template>

                  <template v-slot:[`item.remittance`]="{ item, index }">
                    <v-text-field
                      :value="item.remittance"
                      type="number"
                      name="remittance[]"
                      v-model="remittance[index]"
                      @keydown.enter.prevent="
                        saveRemittance($event, item, index)
                      "
                    ></v-text-field>
                  </template>

                  <template v-slot:[`item.remittanceDate`]="{ item, index }">
                    <v-text-field
                      type="date"
                      name="remittanceDate[]"
                      v-model="remittanceDate[index]"
                      @change="saveRemittanceDate($event, item, index)"
                    ></v-text-field>
                  </template>

                  <template v-slot:[`item.postings`]="{ item }">
                    <div v-for="(posting, i) in item.postings" :key="i">
                      {{
                        `${setToLocaleString(
                          posting.remittance
                        )} - ${formatDate(posting.postingDate)} - ${
                          posting.paymentMethod
                        } `
                      }}
                    </div>
                  </template>

                  <template v-slot:[`item.remittanceDates`]="{ item }">
                    <div v-for="(posting, i) in item.postings" :key="i">
                      {{
                        `${setToLocaleString(
                          posting.remittance
                        )} - ${formatDate(posting.remittanceDate)} - ${
                          posting.paymentMethod
                        }`
                      }}
                    </div>
                  </template>

                  <template v-slot:[`item.paymentMethod`]="{ index }">
                    <v-select
                      :items="paymentMethods"
                      name="selectedPaymentMethod[]"
                      v-model="selectedPaymentMethod[index]"
                      dense
                      class="ml-2 mt-2"
                    >
                    </v-select>
                  </template>

                  <template v-slot:[`item.images`]="{ item }">
                    <v-btn x-small color="warning" @click="showImages(item)"
                      >Images</v-btn
                    >
                  </template>

                  <template v-slot:[`item.total`]="{ item }">
                    <!-- <v-btn x-small color="warning" @click="showImages(item)"
                      >Images</v-btn
                    > -->
                    <a href="#" @click.prevent="showBreakdown(item)"
                      ><strong>{{ setToLocaleString(item.total) }}</strong></a
                    >
                  </template>

                  <template v-slot:[`item.balance`]="{ item }">
                    <strong>{{ item.balance }}</strong>
                  </template>

                  <template v-slot:[`item.date`]="{ item, index }">
                    <span v-if="item.date === null">
                      <v-text-field
                        type="date"
                        name="transDate[]"
                        v-model="transDate[index]"
                      ></v-text-field>
                    </span>

                    <span v-else> {{ formatDate(item.date) }}</span>
                  </template>
                </v-data-table>
              </td>
            </template>

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <download-csv
                ref="downloadUserReport"
                :data="exportData"
                :name="`${fileName}.csv`"
                class="hidden"
              >
              </download-csv>
              <v-btn x-small color="primary" @click="exportPerUser(item)">
                <!-- <download-csv :data="exportData" :name="`${fileName}.csv`"> -->
                <v-icon dense>mdi-download</v-icon>
                Export
                <!-- </download-csv> -->
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <ConfirmationDiaglog ref="confirm"></ConfirmationDiaglog>
    <TransactionBreakdown ref="transactionBreakdown"></TransactionBreakdown>
    <!-- <TransactionImagesDialog
      :dialog="transactionImagesDialog.dialog"
      :dataImg="transactionImagesDialog.data"
      @close="transactionImagesDialog.dialog = !transactionImagesDialog.dialog"
      @response="transactionImagesDialogResponse"
    /> -->
    <TransactionImagesDialog ref="transactionImagesDialog" />
    <Snackbar />
  </v-container>
</template>

<script>
import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";
import ConfirmationDiaglog from "../dialogs/ConfirmationDiaglogv2.vue";
import TransactionImagesDialog from "../dialogs/dealer/TransactionImagesDialogv2.vue";
import TransactionBreakdown from "../dialogs/dealer/TransactionBreakdown.vue";
import Snackbar from "../dialogs/Snackbar.vue";
export default {
  mixins: [ShareableMethods],
  components: {
    ConfirmationDiaglog,
    TransactionImagesDialog,
    TransactionBreakdown,
    Snackbar,
  },
  data() {
    return {
      transactions: [
        {
          balance: 0,
          total: 0,
          date: null,
        },
      ],

      transactionImagesDialog: {
        dialog: false,
        data: null,
      },
      reportList: [
        {
          text: "Summary Report",
          value: "dealer-summary",
        },
      ],
      reportSelected: "",

      isShowBal: false,
      confimationDialog: {
        dialog: false,
        message: "",
        title: "",
      },

      transDate: [],
      remittance: [],
      remittanceDate: [],
      selectedPaymentMethod: [],

      paymentMethods: [],
      exportData: [],
      fileName: "testssss",

      currentDealer: "",
      dealers: [],

      menu: false,
      modal: false,
      dates: [
        moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        moment(this.date)
          .endOf("month")
          .format("YYYY-MM-DD"),
      ],
      search: "",

      table: {
        expanded: [],
        singleExpand: true,
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Retailer Name",
            align: "start",
            value: "retailerName",
            width: "100%",
          },
          { text: "", sortable: false, value: "action" },
          { text: "", value: "data-table-expand" },
        ],
        data: [],
      },
      orginalData: [],
      subTable: {
        headers: [
          {
            text: "Date",
            align: "start",
            value: "date",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
            width: "10%",
          },
          {
            text: "Amount",
            align: "center",
            value: "total",
            sortable: false,
            formatter: (x) => this.setToLocaleString(x),
          },
          {
            text: "Remittance",
            align: "start",
            value: "remittance",
            width: "10%",
            sortable: false,
            // formatter: (x) => this.setToLocaleString(x),
          },
          {
            text: "Remittance Date",
            align: "start",
            value: "remittanceDate",
            sortable: false,
            width: "15%",
          },

          {
            text: "Payment Method",
            align: "start",
            value: "paymentMethod",
            sortable: false,
          },
          {
            text: "Balance",
            align: "center",
            value: "balance",
            sortable: false,
            formatter: (x) => this.setToLocaleString(x),
          },
          {
            text: "Remittance Dates",
            align: "start",
            sortable: false,
            value: "remittanceDates",
            width: "20%",
          },

          {
            text: "Posting Dates",
            align: "start",
            sortable: false,
            value: "postings",
            width: "20%",
          },

          {
            text: "Images",
            align: "center",
            sortable: false,
            value: "images",
          },
        ],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get(
          `/retailer-transactions?dealerId=${this.currentDealer}&startDate=${this.dates[0]}&endDate=${this.dates[1]}`
        )
        .then((response) => {
          const res = response.data.data;
          let newArr = res.retailers;

          if (!this.isShowBal) {
            newArr.forEach(function(subArr) {
              subArr.transactions = subArr.transactions.filter((item) => {
                return item.balance > 0;
              });
            });
          }

          this.table.data = newArr;
          this.table.loading = false;

          let sd = res.retailers;
          console.log(sd);
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    row_classes() {
      return "row_classes";
    },

    // dateFormat(d) {
    //   // return moment(d).format("MMM DD, YYYY");
    //   return this.formatDate(d)
    // },

    async saveRemittance(e, item, index) {
      // if (e.target.value <= 0) {
      //   return false;
      // }
      if (item.date === null && !this.transDate[index]) {
        this.$store.dispatch("addSnackbarMessage", "Select Date");
        this.$store.dispatch("addSnackbar", true);
        return false;
      }

      var remittance = e.target.value;
      var remittanceDate = this.dateFormat(moment().toDate());
      // var paymentMethod = "Cash";

      if (this.remittanceDate[index]) {
        remittanceDate = this.dateFormat(this.remittanceDate[index]);
      }

      if (!this.selectedPaymentMethod[index]) {
        this.$store.dispatch("addSnackbarMessage", "Select Payment Method");
        this.$store.dispatch("addSnackbar", true);
        return false;
      }

      const paymentMethod = this.selectedPaymentMethod[index];
      console.log(item);
      const payload = {
        retailerId: item.retailerId, //04-01-2022
        dateLabel: item.dateLabel
          ? item.dateLabel
          : this.formatDate(this.transDate[index], "MM-DD-YYYY"),
        remittance: remittance,
        remittanceDate: remittanceDate,
        paymentMethod: paymentMethod,
      };

      console.log(payload);

      // this.confimationDialog.dialog = true;
      // this.confimationDialog.title = "Are you sure you want to proceed?";
      // this.confimationDialog.message = `;

      if (
        await this.$refs.confirm.open(
          "Are you sure you want to proceed?",
          `Remittance: <b>${remittance}</b><br>Remittance Date: <b>${remittanceDate}</b><br>Payment Method: <b>${paymentMethod}</b>`
        )
      ) {
        await this.$api
          .post("/retailer-transactions", payload)
          .then(() => {
            // console.log(response);
            this.remittance.splice(index, 1);
            this.remittanceDate.splice(index, 1);
            this.selectedPaymentMethod.splice(index, 1);
            this.getList();
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },

    async getDealers() {
      await this.$api
        .get(`/acquisition/dealers`)
        .then((response) => {
          // console.log(response);
          const newArr = response.data;
          this.dealers = newArr.data.dealers;
          // this.table.data = newArr;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async getPaymentMethods() {
      await this.$api
        .get(`/retailer-transactions/config`)
        .then((response) => {
          console.log(response);
          const newArr = response.data;
          this.paymentMethods = newArr.data.paymentMethodList;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    // confimationDialogResponse(response) {
    //   if (!response) {
    //     this.confimationDialog.dialog = false;
    //     return;
    //   }

    //   this.saveRemittance();
    // },

    // async saveRemittance(e, item, index) {
    //   if (e.target.value <= 0) {
    //     return false;
    //   }

    //   var remittance = e.target.value;
    //   var remittanceDate = this.dateFormat(moment().toDate());
    //   var paymentMethod = "Cash";

    //   if (this.remittanceDate[index]) {
    //     remittanceDate = this.dateFormat(this.remittanceDate[index]);
    //   }
    //   console.log(this.selectedPaymentMethod[index]);
    //   console.log(this.selectedPaymentMethod);

    //   if (this.selectedPaymentMethod[index]) {
    //     paymentMethod = this.selectedPaymentMethod[index];
    //   }

    //   const payload = {
    //     retailerId: item.retailerId,
    //     dateLabel: item.dateLabel,
    //     remittance: remittance,
    //     remittanceDate: remittanceDate,
    //     paymentMethod: paymentMethod,
    //   };

    //   this.confimationDialog.dialog = true;
    //   this.confimationDialog.title = "Are you sure you want to proceed?";
    //   this.confimationDialog.message = `Remittance: <b>${remittance}</b><br>Remittance Date: <b>${remittanceDate}</b><br>Payment Method: <b>${paymentMethod}</b>`;
    //   console.log(payload);

    //   await this.$api
    //     .post("/retailer-transactions", payload)
    //     .then(() => {
    //       // console.log(response);
    //       this.remittance.splice(index, 1);
    //       this.remittanceDate.splice(index, 1);
    //       this.paymentMethod.splice(index, 1);
    //       this.getList();
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //     });
    // },

    saveRemittanceDate(e, item, index) {
      console.log();
      if (!this.remittance[index]) {
        // alert("Please enter Remittance");
        return false;
      }

      const payload = {
        retailerId: item.retailerId,
        dateLabel: item.dateLabel,
        remittance: "",
        remittanceDate: this.formatDate(e),
      };

      console.log(payload);
      console.log(e.target);
      // if (e.target.value) {
      //   console.log(e, item);
      // }
      // console.log(moment(e.target.value).format("MM-DD-YYYY"), item);
    },

    dateFormat(d) {
      return moment(d).format("YYYY-MM-DD");
    },

    async exportPerUser(val) {
      await this.$api
        .get(
          `/retailer-transactions?dealerId=${this.currentDealer}&startDate=${this.dates[0]}&endDate=${this.dates[1]}`
        )
        .then((response) => {
          const res = response.data.data;
          // let newArr = res.retailers;

          let retailers = res.retailers;
          const arr = retailers.filter((e) => e.retailerId == val.retailerId);

          try {
            let exportData = arr[0].transactions.map((item) => {
              const payMethods = this.paymentMethods.reduce(
                (a, key) =>
                  Object.assign(a, {
                    [key]: this.parsePaymentMethod(item.postings, key),
                  }),
                {}
              );

              return {
                Date: this.dateFormat(item.date),
                Amount: item.total,
                Balance: item.balance,
                Remittance: this.parseRemittance(item.postings),
                "Remittance Dates": this.parseRemittanceDates(item.postings),
                "Posting Dates": this.parsePosting(item.postings),
                ...payMethods,
                Remarks: "",
              };
            });

            this.exportData = exportData;
            this.fileName = val.retailerName;
            if (this.exportData.length > 0) {
              this.$refs.downloadUserReport.generate();
            }
          } catch (error) {
            console.log(error);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    parsePaymentMethod(item, key) {
      if (!item) {
        return 0;
      }

      var val = 0;
      item.forEach((elem) => {
        if (elem.paymentMethod == key) {
          return (val += elem.remittance);
        }
      });

      return val;
    },

    parseRemittance(item) {
      if (!item) {
        return null;
      }
      // console
      var val = 0;
      item.forEach((elem) => {
        // if (elem.paymentMethod == key) {
        return (val += elem.remittance);
        // }
      });

      return val;
    },

    parseRemittanceDates(val) {
      if (!val) {
        return null;
      }

      return val
        .map(
          (i) =>
            i.remittance +
            " - " +
            this.formatDate(i.remittanceDate) +
            " - " +
            i.paymentMethod
        )
        .join(",\n");
    },

    parsePosting(val) {
      if (!val) {
        return null;
      }

      return val
        .map(
          (i) =>
            i.remittance +
            " - " +
            this.formatDate(i.postingDate) +
            " - " +
            i.paymentMethod
        )
        .join(",\n");
    },

    showZeroBalance() {
      this.getList();
    },

    async showImages(item) {
      // this.transactionImagesDialog.dialog = true;
      // this.transactionImagesDialog.data = item;
      await this.$refs.transactionImagesDialog.open(item);
    },

    transactionImagesDialogResponse(e) {
      if (e) {
        this.transactionImagesDialog.dialog = false;
      }
    },

    async exportCSV() {
      await this.$api
        .get(
          `retailer-transactions/export?method=dealer-summary&startDate=${this.dates[0]}&endDate=${this.dates[1]}`
        )
        .then((response) => {
          const res = response.data;
          if (res.status) {
            // console.log(res.data.link);
            var fileLink = document.createElement("a");
            fileLink.href = res.data.link;
            fileLink.setAttribute("download", "download");
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
          }
          // console.log(response);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async showBreakdown(item) {
      await this.$refs.transactionBreakdown.open(item);
    },
  },

  created() {
    this.getDealers();
    this.getPaymentMethods();
    this.getList();
  },

  watch: {
    dates() {
      this.getList();
    },
    currentDealer() {
      this.getList();
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
table tr td.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}

.sub-areas {
  border-radius: 0px !important;
}

.v-input {
  font-size: 0.9rem !important;
}

.hidden {
  display: none;
}
</style>
